/**
 * A supplier without contact persons is listed and selectable everywhere, but no bid request can
 * ever reach it — every send path resolves its recipients from the contact list, so a supplier
 * that has none is silently skipped. The views warn instead of hiding, and they all decide it the
 * same way here: per supplier, never per contact person.
 *
 * The lists that call this already carry only active contacts (the supplier list filters supMember
 * by isActive, /supplier/members matches on it), so presence is the whole question.
 */
export default function hasNoContactPersons(contacts?: unknown[] | null): boolean {
  return !contacts?.length;
}
